import { render, staticRenderFns } from "./StructureBinaryTabs.vue?vue&type=template&id=31a7b2dd&scoped=true"
import script from "./StructureBinaryTabs.vue?vue&type=script&lang=js"
export * from "./StructureBinaryTabs.vue?vue&type=script&lang=js"
import style0 from "./StructureBinaryTabs.vue?vue&type=style&index=0&id=31a7b2dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7b2dd",
  null
  
)

export default component.exports